import React, { useMemo, useEffect, useState, useRef } from "react";
import "./index.less";
import {
  AuthingButton,
  AuthingButtonArrow,
} from "../../../components/AuthingButton";
import { useTranslation } from "react-i18next";

export const IdentityMarquee = () => {
  const { t } = useTranslation();
  const swiper2Ref = useRef();
  useEffect(() => {
    const swiper1 = new Swiper(".swiper1", {
      direction: "vertical",
      loop: true,
    });
    swiper2Ref.current = new Swiper("#swiper2", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      direction: "vertical",
      scrollbar: {
        el: ".swiper-scrollbar",
        clickable: true,
      },
      loop: true,
      // autoplay: true,
    });
    swiper1.controller.control = swiper2Ref.current; //Swiper2控制Swiper1，需要初始化Swiper1之后
    swiper2Ref.current.controller.control = swiper1; //Swiper1控制Swiper2，需要初始化Swiper2之后
  }, []);
  const list = useMemo(() => {
    return [
      {
        title1: t("identify.identifyCustomer.item1.title"),
        desc1: t("identify.identifyCustomer.item1.descript1"),
        title2: t("identify.identifyCustomer.item1.subtitle"),
        desc2: t("identify.identifyCustomer.item1.descript2"),
        imgUrl:
          "https://files.authing.co/authing-website/identify-customer-ai.png",
        downUrl:
          "https://host.huiju.cool/file/1789197731c943edad9ac4cd35852049",
      },
      {
        title1: t("identify.identifyCustomer.item2.title"),
        desc1: t("identify.identifyCustomer.item2.descript1"),
        title2: t("identify.identifyCustomer.item2.subtitle"),
        desc2: t("identify.identifyCustomer.item2.descript2"),
        imgUrl:
          "https://files.authing.co/authing-website/identify-customer-coco.png",
        downUrl:
          "https://host.huiju.cool/file/3fe0078f47cf4350a0ee0c3b4293f4ab",
      },
      {
        title1: t("identify.identifyCustomer.item3.title"),
        desc1: t("identify.identifyCustomer.item3.descript1"),
        title2: t("identify.identifyCustomer.item3.subtitle"),
        desc2: t("identify.identifyCustomer.item3.descript2"),
        imgUrl:
          "https://files.authing.co/authing-website/identify-customer-finace.png",
        downUrl:
          "https://host.huiju.cool/file/1789197731c943edad9ac4cd35852049",
      },
    ];
  }, [t]);
  const [visible, setVisible] = useState(false);
  return (
    <div className="identity-marquee">
      <div className="basic-column">
        <div className="manufacturing-marquee-content basic-column flex">
          <div className="swiper swiper1" id="swiper1">
            <div className="swiper-wrapper">
              {list.map((item, index) => {
                return (
                  <div className="swiper-slide" key={`item-${index}`}>
                    <div className="swiper-slide-inner">
                      <div className="title1">{item.title1}</div>
                      <div className="blue-line"></div>
                      <div className="desc1">{item.desc1}</div>
                      <div className="title2  pc-show">{item.title2}</div>
                      <div className="desc2  pc-show">{item.desc2}</div>
                      <div
                        className="pad-show mobile-show"
                        style={{ height: 24 }}
                      ></div>
                      <div>
                        <AuthingButton
                          size="small"
                          style={{ marginRight: 16 }}
                          onClick={() => {
                            window.open("/customer");
                          }}
                        >
                          {t("common.common-more")}
                        </AuthingButton>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div style={{ flex: 24 }}></div>
          <div className="swiper swiper2" id="swiper2">
            <div className="swiper-wrapper">
              {list.map((item, index) => {
                return (
                  <div className="swiper-slide" key={`item-${index}`}>
                    <div
                      style={{
                        background: `url(${item.imgUrl}) center center no-repeat`,
                        backgroundSize: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    ></div>
                  </div>
                );
              })}
            </div>
            <div className="swiper-scrollbar swiper2-scrollbar"></div>
            <div className="swiper2-scrollbar-top">01</div>
            <div className="swiper2-scrollbar-bottom">03</div>
            <div className="swiper-button-prev swiper2-button-prev swiper2-button">
              <i className="icon authing-icon authing-arrow-left-s-line"></i>
            </div>
            <div className="swiper-button-next swiper2-button-next swiper2-button">
              <i className="icon authing-icon authing-arrow-right-s-line"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
